export default {

    addSingleLocalStorage(value, key) {
        var store = "";
        if (JSON.parse(localStorage.getItem(key))) {
            store = JSON.parse(localStorage.getItem(key));
        }
        store = value;
        if (store != "") {
            localStorage.setItem(key, JSON.stringify(store));
        }
    },

    addSingleLocalStorageFree(value, key) {
        var store = "";
        if (JSON.parse(localStorage.getItem(key))) {
            store = JSON.parse(localStorage.getItem(key));
        }
        store = value;
        localStorage.setItem(key, JSON.stringify(store));
    },

    getSingleValueInLocalStorage(key) {
        var store = "";
        if (JSON.parse(localStorage.getItem(key))) {
            store = JSON.parse(localStorage.getItem(key));
        }
        return store;
    },

    addLocalStorage(value, key) {
        var store = [];
        if (JSON.parse(localStorage.getItem(key))) {
            store = JSON.parse(localStorage.getItem(key));
        }
        if (store.indexOf(value) == -1) {
            store.push(value);
        }
        if (store.length > 0) {
            localStorage.setItem(key, JSON.stringify(store));
        }
    },
    
    deleteValueLocalStorage(value, key) {
        var store = [];

        if (JSON.parse(localStorage.getItem(key))) {
            store = JSON.parse(localStorage.getItem(key));
        }

        var position = store.indexOf(value);
        if (position != -1) {
            store.splice(position, 1);
        }

        if (store.length > 0) {
            localStorage.setItem(key, JSON.stringify(store));
        }
    },

    getValueInLocalStorage(key) {
        var store = [];
        if (JSON.parse(localStorage.getItem(key))) {
            store = JSON.parse(localStorage.getItem(key));
        }
        return store;
    },

    removeLocalStorage (key){
        if(JSON.parse(localStorage.getItem(key)))
            localStorage.removeItem(key);
    },

    addlocalStorageEcnrypt(vm, index, value, pass, key){
        //index-nombre del mapa value-valor a encriptar pass-contraseña de encriptación key-llave del local storage 
        var map = new Map();
        let encryptText = JSON.stringify(value);

        let tempMap = new Map(JSON.parse(localStorage.getItem(key)));
        if(tempMap.size > 0){
            map = new Map(JSON.parse(localStorage.getItem(key)))
        }
        
        if(map.has(index)) {
            map.set(index, vm.CryptoJS.AES.encrypt(encryptText, pass).toString());
        }else{
            map.set(index, vm.CryptoJS.AES.encrypt(encryptText, pass).toString());
        }
       
        if (map.size > 0) {
            localStorage.setItem(key, JSON.stringify(Array.from(map.entries())));
        }
    },

    getLocalStoragreDecrypt(vm, index, pass, key){
        //index-nombre del mapa pass-contraseña de encriptación key-llave del local storage 
        var map = new Map();
        let tempMap = new Map(JSON.parse(localStorage.getItem(key)));
        if(tempMap.size > 0){
            map = new Map(JSON.parse(localStorage.getItem(key)))
        }
        return tempMap.has(index) ? JSON.parse(vm.CryptoJS.AES.decrypt(map.get(index), pass).toString(vm.CryptoJS.enc.Utf8)) : null;
    },

    getSizeLocalStorage(key){
        let tempMap = new Map(JSON.parse(localStorage.getItem(key)));
        return tempMap.size > 0 ? tempMap.size : 0;
    },
    guardarEnSesionInfoReporte(data){
        let aux_nrreporte = data.nrreporte.split('-');
        let _svindice = aux_nrreporte[1];
        let _nrreporte = aux_nrreporte[0];

        let reporte = {
            nrreporte: _nrreporte,
            svindice: _svindice,
            aiclave: data.aiclave,
        }

        sessionStorage.removeItem('reporte');
        sessionStorage.setItem('reporte', JSON.stringify(reporte));
    },

}